import { OnboardingLoginPage } from 'src/legacy/components/Onboarding/Login';
import { ClientLogin } from 'src/routes/auth/ClientLogin';
import { RouteAction } from 'src/routes/types';
import { getLoginImageURL } from 'src/utils/ImageUtils';

const action: RouteAction = (context) => {
  const { isAssemblyDomain, query } = context;
  const isInternalUser = context.portalConfig.viewMode === 'internal';

  const appTitle = isAssemblyDomain ? 'Assembly' : 'Copilot';

  const { title, description, socialShareImage } =
    query?.step === 'forgotPassword'
      ? {
          title: `${appTitle} • Forgot Password`,
          description: `Recover your password to log back in to your ${appTitle} account. `,
          socialShareImage: '/images/copilot_social_image.jpg',
        }
      : {
          title: `${appTitle} • Log in`,
          description: `Log in to the ${appTitle} Dashboard to manage your business.`,
          socialShareImage: '/images/copilot_social_image.jpg',
        };
  const prefetchUrls = isInternalUser
    ? []
    : [
        getLoginImageURL(
          context.portalConfig.assets.authImage.signInUrl || '',
          {
            resize: { width: 580 * 2, height: 580 * 2 },
          },
        ),
      ];
  return {
    chunks: ['login'],
    ...(isInternalUser ? { title, description, socialShareImage } : {}),
    component: isInternalUser ? <OnboardingLoginPage /> : <ClientLogin />,
    prefetchUrls,
  };
};

export default action;
